import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudesPersonaAutorizacionesModel } from 'src/app/models/commands/acceso-personal/AccesoPersonalRegistrarModel';
import { ISolicitudPersonaDocumentoValidarModel } from 'src/app/models/commands/solicitudes/solicitud-persona/interfaces/ISolicitudPersonaDocumentoValidarModel';
import { ISolicitudPersonaValidarEmpresaModel } from 'src/app/models/commands/solicitudes/solicitud-persona/interfaces/ISolicitudPersonaValidarEmpresaModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudPersonaModel } from 'src/app/models/interfaces/solicitud/ISolicitudPersonaModel';
import { ISolicitudPersonalAsignarDocumentoModel } from 'src/app/models/interfaces/solicitud/personal/ISolicitudPersonalAsignarDocumentoModel';
import { ISolicitudPersonaValidarModel } from 'src/app/models/interfaces/solicitud/personal/ISolicitudPersonaValidarModel';
import { InduccionBaseModel } from 'src/app/models/queries/inducciones/InduccionBaseModel';
import { FilterSolicitudPersonaPendienteAccesoModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaPendienteAccesoModel';
import { FilterSolicitudPersonaPendienteInduccionModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaPendienteInduccion';
import { SolicitudPersonaPendienteAccesoBaseModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaPendienteAccesoBaseModel';
import { SolicitudResultadoBusqueda } from 'src/app/models/solicitud/solicitudResultadoBusqueda';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudPersonaService {

  private configUrl = [environment.apiGatewayUrl, 'solicitudes'].join('/');

  constructor(
    private http: HttpClient,
    private datepipe: DatePipe
    ) { }

  guardar(model: ISolicitudPersonaModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${model.idSolicitud}/personas`, model);
  }

  validarempresa(model: ISolicitudPersonaValidarEmpresaModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/personas/validarempresa`, model);
  }

  asignardocumento(idSolicitud: number,model: ISolicitudPersonalAsignarDocumentoModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/${idSolicitud}/personasdocumento`, model);
  }

  getById(idSolicitud: number, idSolicitudPersona: number): Observable<ISolicitudPersonaModel> {
    return this.http.get<ISolicitudPersonaModel>(`${this.configUrl}/${idSolicitud}/personas/${idSolicitudPersona}`);
  }

  validar(model: ISolicitudPersonaValidarModel){
    return this.http.post<ISolicitudPersonaValidarModel>(`${this.configUrl}/personas/validar`, model);
  }

  autorizar(model: SolicitudesPersonaAutorizacionesModel){
    return this.http.post<ActionResultModel>(`${this.configUrl}/personas/autorizar`, model);
  }
  
  renovar(model: ISolicitudPersonaDocumentoValidarModel){
    return this.http.post<ISolicitudPersonaDocumentoValidarModel>(`${this.configUrl}/personas/documentos/validar`, model);
  }

  getAllPendienteInduccion(modelFilter: FilterSolicitudPersonaPendienteInduccionModel): Observable<SearchResultModel<InduccionBaseModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${modelFilter.page}`);
    queryParams.push(`take=${modelFilter.pageSize}`);
    
    if (modelFilter.nombreEmpleado !== '') {
      queryParams.push(`empleado=${modelFilter.nombreEmpleado}`);
    }

    if (modelFilter.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${modelFilter.nroDocumento}`);
    }

    if (modelFilter.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${modelFilter.codigoSolicitud}`);
    }

    if (modelFilter.solicitante !== '') {
      queryParams.push(`solicitante=${modelFilter.solicitante}`);
    }
    
    if(modelFilter.sedes.length > 0)
      queryParams.push(`sedes=${modelFilter.sedes.join(',')}`);

    if(modelFilter.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(modelFilter.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(modelFilter.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(modelFilter.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }

    if (modelFilter.nombreContratista !== '') {
      queryParams.push(`contratista=${modelFilter.nombreContratista}`);
    }
    
    if(modelFilter.idCompania != 0){
      queryParams.push(`companias=${modelFilter.idCompania}`); 
    }

    return this.http.get<SearchResultModel<InduccionBaseModel[]>>(
      `${this.configUrl}/personas/pendiente-induccion?${queryParams.join('&')}`
    );
  }

  getAllPendienteInduccionToExport(modelFilter: FilterSolicitudPersonaPendienteInduccionModel): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (modelFilter.nombreEmpleado !== '') {
      queryParams.push(`empleado=${modelFilter.nombreEmpleado}`);
    }

    if (modelFilter.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${modelFilter.nroDocumento}`);
    }

    if (modelFilter.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${modelFilter.codigoSolicitud}`);
    }

    if (modelFilter.solicitante !== '') {
      queryParams.push(`solicitante=${modelFilter.solicitante}`);
    }
    
    if(modelFilter.sedes.length > 0)
      queryParams.push(`sedes=${modelFilter.sedes.join(',')}`);

    if(modelFilter.fechaInicioAprobacion){
      queryParams.push(`fechaInicioAprobacion=${this.datepipe.transform(modelFilter.fechaInicioAprobacion, 'yyyy-MM-dd')}`);
    }

    if(modelFilter.fechaFinAprobacion){
      queryParams.push(`fechaFinAprobacion=${this.datepipe.transform(modelFilter.fechaFinAprobacion, 'yyyy-MM-dd')}`);
    }

    if (modelFilter.nombreContratista !== '') {
      queryParams.push(`contratista=${modelFilter.nombreContratista}`);
    }
    
    if(modelFilter.idCompania != 0){
      queryParams.push(`companias=${modelFilter.idCompania}`); 
    }

    return this.http.get(
      `${this.configUrl}/personas/pendiente-induccion/exportar?${queryParams.join('&')}`, { responseType: 'blob'}
    );
  }

  getAllPendienteAcceso(modelFilter: FilterSolicitudPersonaPendienteAccesoModel): Observable<SearchResultModel<SolicitudPersonaPendienteAccesoBaseModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${modelFilter.page}`);
    queryParams.push(`take=${modelFilter.pageSize}`);
    
    if (modelFilter.nombreEmpleado !== '') {
      queryParams.push(`empleado=${modelFilter.nombreEmpleado}`);
    }

    if (modelFilter.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${modelFilter.nroDocumento}`);
    }

    if (modelFilter.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${modelFilter.codigoSolicitud}`);
    }
    
    if(modelFilter.sedes.length > 0)
      queryParams.push(`sedes=${modelFilter.sedes.join(',')}`);

    if (modelFilter.solicitante !== '') {
      queryParams.push(`solicitante=${modelFilter.solicitante}`);
    }


    if(modelFilter.fechaInicioInduccion){
      queryParams.push(`fechaInicio=${this.datepipe.transform(modelFilter.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(modelFilter.fechaFinInduccion){
      queryParams.push(`fechaFin=${this.datepipe.transform(modelFilter.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if (modelFilter.nombreContratista !== '') {
      queryParams.push(`contratista=${modelFilter.nombreContratista}`);
    }
    
    if(modelFilter.idCompania != 0){
      queryParams.push(`companias=${modelFilter.idCompania}`); 
    }

    return this.http.get<SearchResultModel<SolicitudPersonaPendienteAccesoBaseModel[]>>(
      `${this.configUrl}/personas/pendiente-acceso?${queryParams.join('&')}`
    );
  }

  getAllPendienteAccesoToExport(modelFilter: FilterSolicitudPersonaPendienteAccesoModel): Observable<Blob> {
    let queryParams: string[] = new Array<string>();
    
    if (modelFilter.nombreEmpleado !== '') {
      queryParams.push(`empleado=${modelFilter.nombreEmpleado}`);
    }

    if (modelFilter.nroDocumento !== '') {
      queryParams.push(`nroDocumento=${modelFilter.nroDocumento}`);
    }

    if (modelFilter.codigoSolicitud !== '') {
      queryParams.push(`codigoSolicitud=${modelFilter.codigoSolicitud}`);
    }
    
    if(modelFilter.sedes.length > 0)
      queryParams.push(`sedes=${modelFilter.sedes.join(',')}`);

    if (modelFilter.solicitante !== '') {
      queryParams.push(`solicitante=${modelFilter.solicitante}`);
    }


    if(modelFilter.fechaInicioInduccion){
      queryParams.push(`fechaInicio=${this.datepipe.transform(modelFilter.fechaInicioInduccion, 'yyyy-MM-dd')}`);
    }

    if(modelFilter.fechaFinInduccion){
      queryParams.push(`fechaFin=${this.datepipe.transform(modelFilter.fechaFinInduccion, 'yyyy-MM-dd')}`);
    }

    if (modelFilter.nombreContratista !== '') {
      queryParams.push(`contratista=${modelFilter.nombreContratista}`);
    }

    return this.http.get(
      `${this.configUrl}/personas/pendiente-acceso/exportar?${queryParams.join('&')}`, { responseType: 'blob' }
    );
  }

  getPendienteAccesoSolicitud(idSolicitud: number): Observable<SearchResultModel<SolicitudPersonaPendienteAccesoBaseModel[]>> {
    return this.http.get<SearchResultModel<SolicitudPersonaPendienteAccesoBaseModel[]>>(
      `${this.configUrl}/${idSolicitud}/personas/pendiente-acceso`
    );
  }

  eliminar(idSolicitudPersona: number){
    return this.http.delete<ActionResultModel>(`${this.configUrl}/personas/${idSolicitudPersona}`);
  }
}
